import { cn } from "@/lib/utils.ts";

export interface Tab {
  id: string;
  label: string;
}

interface CustomTabsProps {
  tabs: Tab[];
  activeTab: string;
  onChangeTab: (tabId: string) => void;
}

export function CustomTabs({ tabs, activeTab, onChangeTab }: CustomTabsProps) {
  return (
    <div className="w-full justify-start items-start gap-4 inline-flex">
      {tabs.map((tab) => (
        <div
          className="flex-col min-w-12 justify-center items-center gap-2 inline-flex cursor-pointer active:opacity-50 transition-opacity"
          key={tab.id}
          onClick={() => onChangeTab(tab.id)}
        >
          <div className="text-zinc-400 text-base font-normal">{tab.label}</div>
          <div
            className={cn(
              "self-stretch h-px border-2 border-black transition-opacity duration-500",
              {
                "opacity-0": tab.id !== activeTab,
              },
            )}
          />
        </div>
      ))}
    </div>
  );
}
